<div class="notification-receipt" [ngClass]="receipt.content.type">
  <div class="notification-receipt--start">
    <div class="notification-receipt--state" [ngClass]="receipt.state || 'unseen'"></div>
  </div>

  <div class="notification-receipt--center" (click)="$event.stopPropagation(); clicked.emit()">
    <div [class.show-full-info]="isFullInfo" class="notification-receipt--title">
      {{ receipt.content.body.title }}
    </div>

    <div
      studioEllipsisActive
      (ellipsisChanged)="isEllipsisActive = $event"
      [innerHtml]="receipt.content.body.message"
      [class.show-full-info]="isFullInfo"
      class="notification-receipt--message"
    ></div>

    <studio-icon
      *ngIf="isEllipsisActive"
      (click)="showFullInfo()"
      [direction]="isFullInfo ? 'up' : 'down'"
      class="notification-receipt--expandable"
      name="chevron"
    ></studio-icon>

    <div class="notification-receipt--datetime-published">
      {{ receipt.content.datetimePublished | timeUntilNow : { addSuffix: true } }}
    </div>
  </div>
</div>
